import { useContext } from 'react';

// Material UI
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';

// context
import { Context } from '../../../context/Context';

const Modal = () => {
  const { state, setState } = useContext(Context);
  const lang = state.lang;
  const { title, open, children, onConfirm, onCancel, noActions, textConfirm, maxWidth, fullWidth } = state.modal;

  const handleClose = () => {
    setState((prev) => ({ ...prev, modal: { ...prev.modal, open: false } }));
    if (onCancel) onCancel();
  };

  const confirmLabel =
    textConfirm === 'save'
      ? lang === 'ES'
        ? 'Guardar'
        : 'Save'
      : textConfirm || (lang === 'ES' ? 'Aceptar' : 'Accept');

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth={!!fullWidth}
      maxWidth={maxWidth || 'sm'}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
      <DialogContent style={{ paddingTop: '15px' }}>{children}</DialogContent>
      {!noActions ? (
        <DialogActions>
          <Button onClick={() => handleClose()}>{lang === 'ES' ? 'Cancelar' : 'Cancel'}</Button>
          {onConfirm ? (
            <Button onClick={onConfirm} autoFocus>
              {confirmLabel}
            </Button>
          ) : null}
        </DialogActions>
      ) : null}
    </Dialog>
  );
};

export default Modal;
